import { SPOTTER_STRINGS } from "../strings";
import { AnchorJobSourceKind } from "./service";

/**
 * A collection is never named alone — clubs name footage folders after the
 * camera that shot them, so a bare collection name like `"ARRI A012"` identifies nothing without
 * its parent (`"2026 Preseason"`) above it. This decides what goes in that parent slot for the
 * full-page anchor editor's breadcrumb, mirroring `controlRoom/rowLabel.ts`'s own
 * collection/saved-search precedence for the rail row (same rule, same two special cases) rather
 * than inventing a second one:
 *
 * - `collection`: the resolved `parentCollectionName` (`AnchorJob`'s own field, `null` for a
 *   root-level collection or a resolution failure — the breadcrumb then just shows the collection
 *   name alone, same as a root-level rail row does).
 * - `saved_search`: a saved search has no parent collection to resolve — the literal string
 *   "Saved Search" always goes in that slot (never `null`), same literal
 *   `controlRoom.savedSearchLabel` the rail row already shows for this case.
 * - `assets`: no parent concept at all (an ad-hoc asset list isn't inside any collection) — `null`.
 */
export function anchorJobParentLabel(
  sourceKind: AnchorJobSourceKind,
  parentCollectionName: string | null
): string | null {
  if (sourceKind === "saved_search") {
    return SPOTTER_STRINGS.controlRoom.savedSearchLabel;
  }
  if (sourceKind === "collection") {
    return parentCollectionName;
  }
  return null;
}
